var _path, _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogofull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 70,
    viewBox: "0 0 356 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.36 42L166.04 25.2H167.792L175.472 42H173.6L166.544 26.232H167.264L160.208 42H158.36ZM161.384 37.512L161.912 36.072H171.68L172.208 37.512H161.384ZM187.523 42L182.339 35.76L183.755 34.92L189.539 42H187.523ZM178.283 42V29.4H179.987V42H178.283ZM179.459 36.384V34.92H183.515V36.384H179.459ZM183.899 35.88L182.315 35.64L187.331 29.4H189.179L183.899 35.88ZM199.818 42V39.216L199.746 38.76V34.104C199.746 33.032 199.442 32.208 198.834 31.632C198.242 31.056 197.354 30.768 196.17 30.768C195.354 30.768 194.578 30.904 193.842 31.176C193.106 31.448 192.482 31.808 191.97 32.256L191.202 30.984C191.842 30.44 192.61 30.024 193.506 29.736C194.402 29.432 195.346 29.28 196.338 29.28C197.97 29.28 199.226 29.688 200.106 30.504C201.002 31.304 201.45 32.528 201.45 34.176V42H199.818ZM195.474 42.12C194.53 42.12 193.706 41.968 193.002 41.664C192.314 41.344 191.786 40.912 191.418 40.368C191.05 39.808 190.866 39.168 190.866 38.448C190.866 37.792 191.018 37.2 191.322 36.672C191.642 36.128 192.154 35.696 192.858 35.376C193.578 35.04 194.538 34.872 195.738 34.872H200.082V36.144H195.786C194.57 36.144 193.722 36.36 193.242 36.792C192.778 37.224 192.546 37.76 192.546 38.4C192.546 39.12 192.826 39.696 193.386 40.128C193.946 40.56 194.73 40.776 195.738 40.776C196.698 40.776 197.522 40.56 198.21 40.128C198.914 39.68 199.426 39.04 199.746 38.208L200.13 39.384C199.81 40.216 199.25 40.88 198.45 41.376C197.666 41.872 196.674 42.12 195.474 42.12ZM214.627 41.184V30.888H208.555L208.411 33.696C208.379 34.544 208.323 35.376 208.243 36.192C208.179 37.008 208.059 37.76 207.883 38.448C207.723 39.12 207.491 39.672 207.187 40.104C206.883 40.52 206.491 40.76 206.011 40.824L204.307 40.512C204.803 40.528 205.211 40.352 205.531 39.984C205.851 39.6 206.099 39.08 206.275 38.424C206.451 37.768 206.579 37.024 206.659 36.192C206.739 35.344 206.803 34.48 206.851 33.6L207.019 29.4H216.331V41.184H214.627ZM203.779 45.048V40.512H218.299V45.048H216.691V42H205.387V45.048H203.779ZM227.019 42.12C225.707 42.12 224.555 41.848 223.563 41.304C222.571 40.744 221.795 39.984 221.235 39.024C220.675 38.048 220.395 36.936 220.395 35.688C220.395 34.44 220.659 33.336 221.187 32.376C221.731 31.416 222.467 30.664 223.395 30.12C224.339 29.56 225.395 29.28 226.563 29.28C227.747 29.28 228.795 29.552 229.707 30.096C230.635 30.624 231.363 31.376 231.891 32.352C232.419 33.312 232.683 34.424 232.683 35.688C232.683 35.768 232.675 35.856 232.659 35.952C232.659 36.032 232.659 36.12 232.659 36.216H221.691V34.944H231.747L231.075 35.448C231.075 34.536 230.875 33.728 230.475 33.024C230.091 32.304 229.563 31.744 228.891 31.344C228.219 30.944 227.443 30.744 226.563 30.744C225.699 30.744 224.923 30.944 224.235 31.344C223.547 31.744 223.011 32.304 222.627 33.024C222.243 33.744 222.051 34.568 222.051 35.496V35.76C222.051 36.72 222.259 37.568 222.675 38.304C223.107 39.024 223.699 39.592 224.451 40.008C225.219 40.408 226.091 40.608 227.067 40.608C227.835 40.608 228.547 40.472 229.203 40.2C229.875 39.928 230.451 39.512 230.931 38.952L231.891 40.056C231.331 40.728 230.627 41.24 229.779 41.592C228.947 41.944 228.027 42.12 227.019 42.12ZM236.455 42V29.4H238.183L243.895 39.072H243.175L248.983 29.4H250.567V42H249.007V31.344L249.319 31.488L243.895 40.464H243.127L237.655 31.392L238.015 31.32V42H236.455ZM255.416 42V29.4H257.12V39.408L265.544 29.4H267.056V42H265.352V31.968L256.952 42H255.416ZM279.908 36.672C279.172 36.992 278.428 37.248 277.676 37.44C276.94 37.616 276.204 37.704 275.468 37.704C273.98 37.704 272.804 37.368 271.94 36.696C271.076 36.008 270.644 34.952 270.644 33.528V29.4H272.324V33.432C272.324 34.392 272.636 35.112 273.26 35.592C273.884 36.072 274.724 36.312 275.78 36.312C276.42 36.312 277.092 36.232 277.796 36.072C278.5 35.896 279.212 35.648 279.932 35.328L279.908 36.672ZM279.764 42V29.4H281.468V42H279.764ZM291.707 42.12C290.395 42.12 289.243 41.848 288.251 41.304C287.259 40.744 286.483 39.984 285.923 39.024C285.363 38.048 285.083 36.936 285.083 35.688C285.083 34.44 285.347 33.336 285.875 32.376C286.419 31.416 287.155 30.664 288.083 30.12C289.027 29.56 290.083 29.28 291.251 29.28C292.435 29.28 293.483 29.552 294.395 30.096C295.323 30.624 296.051 31.376 296.579 32.352C297.107 33.312 297.371 34.424 297.371 35.688C297.371 35.768 297.363 35.856 297.347 35.952C297.347 36.032 297.347 36.12 297.347 36.216H286.379V34.944H296.435L295.763 35.448C295.763 34.536 295.563 33.728 295.163 33.024C294.779 32.304 294.251 31.744 293.579 31.344C292.907 30.944 292.131 30.744 291.251 30.744C290.387 30.744 289.611 30.944 288.923 31.344C288.235 31.744 287.699 32.304 287.315 33.024C286.931 33.744 286.739 34.568 286.739 35.496V35.76C286.739 36.72 286.947 37.568 287.363 38.304C287.795 39.024 288.387 39.592 289.139 40.008C289.907 40.408 290.779 40.608 291.755 40.608C292.523 40.608 293.235 40.472 293.891 40.2C294.563 39.928 295.139 39.512 295.619 38.952L296.579 40.056C296.019 40.728 295.315 41.24 294.467 41.592C293.635 41.944 292.715 42.12 291.707 42.12ZM306.423 42.12C305.175 42.12 304.055 41.848 303.063 41.304C302.087 40.744 301.319 39.984 300.759 39.024C300.199 38.048 299.919 36.936 299.919 35.688C299.919 34.424 300.199 33.312 300.759 32.352C301.319 31.392 302.087 30.64 303.063 30.096C304.055 29.552 305.175 29.28 306.423 29.28C307.495 29.28 308.463 29.488 309.327 29.904C310.191 30.32 310.871 30.944 311.367 31.776L310.095 32.64C309.663 32 309.127 31.528 308.487 31.224C307.847 30.92 307.151 30.768 306.399 30.768C305.503 30.768 304.695 30.976 303.975 31.392C303.255 31.792 302.687 32.36 302.271 33.096C301.855 33.832 301.647 34.696 301.647 35.688C301.647 36.68 301.855 37.544 302.271 38.28C302.687 39.016 303.255 39.592 303.975 40.008C304.695 40.408 305.503 40.608 306.399 40.608C307.151 40.608 307.847 40.456 308.487 40.152C309.127 39.848 309.663 39.384 310.095 38.76L311.367 39.624C310.871 40.44 310.191 41.064 309.327 41.496C308.463 41.912 307.495 42.12 306.423 42.12ZM323.906 42L318.722 35.76L320.138 34.92L325.922 42H323.906ZM314.666 42V29.4H316.37V42H314.666ZM315.842 36.384V34.92H319.898V36.384H315.842ZM320.282 35.88L318.698 35.64L323.714 29.4H325.562L320.282 35.88ZM333.35 42.12C332.134 42.12 331.038 41.848 330.062 41.304C329.102 40.744 328.342 39.984 327.782 39.024C327.222 38.048 326.942 36.936 326.942 35.688C326.942 34.424 327.222 33.312 327.782 32.352C328.342 31.392 329.102 30.64 330.062 30.096C331.022 29.552 332.118 29.28 333.35 29.28C334.598 29.28 335.702 29.552 336.662 30.096C337.638 30.64 338.398 31.392 338.942 32.352C339.502 33.312 339.782 34.424 339.782 35.688C339.782 36.936 339.502 38.048 338.942 39.024C338.398 39.984 337.638 40.744 336.662 41.304C335.686 41.848 334.582 42.12 333.35 42.12ZM333.35 40.608C334.262 40.608 335.07 40.408 335.774 40.008C336.478 39.592 337.03 39.016 337.43 38.28C337.846 37.528 338.054 36.664 338.054 35.688C338.054 34.696 337.846 33.832 337.43 33.096C337.03 32.36 336.478 31.792 335.774 31.392C335.07 30.976 334.27 30.768 333.374 30.768C332.478 30.768 331.678 30.976 330.974 31.392C330.27 31.792 329.71 32.36 329.294 33.096C328.878 33.832 328.67 34.696 328.67 35.688C328.67 36.664 328.878 37.528 329.294 38.28C329.71 39.016 330.27 39.592 330.974 40.008C331.678 40.408 332.47 40.608 333.35 40.608ZM348.824 42.12C347.512 42.12 346.36 41.848 345.368 41.304C344.376 40.744 343.6 39.984 343.04 39.024C342.48 38.048 342.2 36.936 342.2 35.688C342.2 34.44 342.464 33.336 342.992 32.376C343.536 31.416 344.272 30.664 345.2 30.12C346.144 29.56 347.2 29.28 348.368 29.28C349.552 29.28 350.6 29.552 351.512 30.096C352.44 30.624 353.168 31.376 353.696 32.352C354.224 33.312 354.488 34.424 354.488 35.688C354.488 35.768 354.48 35.856 354.464 35.952C354.464 36.032 354.464 36.12 354.464 36.216H343.496V34.944H353.552L352.88 35.448C352.88 34.536 352.68 33.728 352.28 33.024C351.896 32.304 351.368 31.744 350.696 31.344C350.024 30.944 349.248 30.744 348.368 30.744C347.504 30.744 346.728 30.944 346.04 31.344C345.352 31.744 344.816 32.304 344.432 33.024C344.048 33.744 343.856 34.568 343.856 35.496V35.76C343.856 36.72 344.064 37.568 344.48 38.304C344.912 39.024 345.504 39.592 346.256 40.008C347.024 40.408 347.896 40.608 348.872 40.608C349.64 40.608 350.352 40.472 351.008 40.2C351.68 39.928 352.256 39.512 352.736 38.952L353.696 40.056C353.136 40.728 352.432 41.24 351.584 41.592C350.752 41.944 349.832 42.12 348.824 42.12Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.62 44L108.66 18.8H113.34L108.3 44H103.62ZM109.056 33.344L109.812 29.348H118.272L117.552 33.344H109.056ZM120.612 44L114.528 31.688L118.416 29.528L125.616 44H120.612ZM118.488 31.868L114.024 31.328L125.148 18.8H130.404L118.488 31.868ZM128.827 44L133.867 18.8H153.487L152.695 22.652H137.719L136.495 28.844H143.947C146.539 28.844 148.507 29.408 149.851 30.536C151.219 31.64 151.903 33.26 151.903 35.396C151.903 37.196 151.435 38.732 150.499 40.004C149.563 41.276 148.219 42.26 146.467 42.956C144.715 43.652 142.615 44 140.167 44H128.827ZM134.191 40.4H140.671C142.663 40.4 144.223 39.992 145.351 39.176C146.503 38.336 147.079 37.196 147.079 35.756C147.079 34.604 146.683 33.764 145.891 33.236C145.123 32.708 143.911 32.444 142.255 32.444H135.775L134.191 40.4Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.256 44.36C88.712 44.36 86.54 43.904 84.74 42.992C82.94 42.08 81.56 40.82 80.6 39.212C79.664 37.58 79.196 35.708 79.196 33.596C79.196 31.46 79.556 29.48 80.276 27.656C80.996 25.808 82.04 24.2 83.408 22.832C84.776 21.464 86.408 20.396 88.304 19.628C90.2 18.836 92.312 18.44 94.64 18.44C97.16 18.44 99.32 18.896 101.12 19.808C102.92 20.72 104.3 21.992 105.26 23.624C106.22 25.232 106.7 27.092 106.7 29.204C106.7 31.34 106.328 33.332 105.584 35.18C104.864 37.004 103.82 38.6 102.452 39.968C101.084 41.336 99.452 42.416 97.556 43.208C95.684 43.976 93.584 44.36 91.256 44.36ZM91.652 40.256C93.236 40.256 94.664 39.98 95.936 39.428C97.208 38.852 98.288 38.072 99.176 37.088C100.088 36.08 100.784 34.928 101.264 33.632C101.744 32.312 101.984 30.932 101.984 29.492C101.984 28.124 101.684 26.912 101.084 25.856C100.484 24.8 99.608 23.984 98.456 23.408C97.304 22.832 95.888 22.544 94.208 22.544C92.648 22.544 91.22 22.832 89.924 23.408C88.652 23.96 87.56 24.74 86.648 25.748C85.76 26.732 85.076 27.884 84.596 29.204C84.14 30.5 83.912 31.868 83.912 33.308C83.912 34.676 84.2 35.888 84.776 36.944C85.376 38 86.252 38.816 87.404 39.392C88.556 39.968 89.972 40.256 91.652 40.256Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.62 44L107.66 18.8H112.34L107.3 44H102.62ZM108.056 33.344L108.812 29.348H117.272L116.552 33.344H108.056ZM119.612 44L113.528 31.688L117.416 29.528L124.616 44H119.612ZM117.488 31.868L113.024 31.328L124.148 18.8H129.404L117.488 31.868ZM127.827 44L132.867 18.8H152.487L151.695 22.652H136.719L135.495 28.844H142.947C145.539 28.844 147.507 29.408 148.851 30.536C150.219 31.64 150.903 33.26 150.903 35.396C150.903 37.196 150.435 38.732 149.499 40.004C148.563 41.276 147.219 42.26 145.467 42.956C143.715 43.652 141.615 44 139.167 44H127.827ZM133.191 40.4H139.671C141.663 40.4 143.223 39.992 144.351 39.176C145.503 38.336 146.079 37.196 146.079 35.756C146.079 34.604 145.683 33.764 144.891 33.236C144.123 32.708 142.911 32.444 141.255 32.444H134.775L133.191 40.4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.256 44.36C87.712 44.36 85.54 43.904 83.74 42.992C81.94 42.08 80.56 40.82 79.6 39.212C78.664 37.58 78.196 35.708 78.196 33.596C78.196 31.46 78.556 29.48 79.276 27.656C79.996 25.808 81.04 24.2 82.408 22.832C83.776 21.464 85.408 20.396 87.304 19.628C89.2 18.836 91.312 18.44 93.64 18.44C96.16 18.44 98.32 18.896 100.12 19.808C101.92 20.72 103.3 21.992 104.26 23.624C105.22 25.232 105.7 27.092 105.7 29.204C105.7 31.34 105.328 33.332 104.584 35.18C103.864 37.004 102.82 38.6 101.452 39.968C100.084 41.336 98.452 42.416 96.556 43.208C94.684 43.976 92.584 44.36 90.256 44.36ZM90.652 40.256C92.236 40.256 93.664 39.98 94.936 39.428C96.208 38.852 97.288 38.072 98.176 37.088C99.088 36.08 99.784 34.928 100.264 33.632C100.744 32.312 100.984 30.932 100.984 29.492C100.984 28.124 100.684 26.912 100.084 25.856C99.484 24.8 98.608 23.984 97.456 23.408C96.304 22.832 94.888 22.544 93.208 22.544C91.648 22.544 90.22 22.832 88.924 23.408C87.652 23.96 86.56 24.74 85.648 25.748C84.76 26.732 84.076 27.884 83.596 29.204C83.14 30.5 82.912 31.868 82.912 33.308C82.912 34.676 83.2 35.888 83.776 36.944C84.376 38 85.252 38.816 86.404 39.392C87.556 39.968 88.972 40.256 90.652 40.256Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_1154)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_42_1154)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_42_1154)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5864,
    cy: 30.3882,
    rx: 4.43415,
    ry: 4.43415,
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5305 28.0173L21.1663 20.3372C22.8467 16.7876 25.5351 13.8113 28.8959 11.7795L34.1394 8.60953C36.9305 6.92224 40.3328 6.58111 43.4033 7.68072C45.8702 8.56419 47.9336 10.3112 49.2119 12.5987L55.3767 23.6309L47.7788 12.6812C46.5158 10.8612 44.5959 9.60221 42.4233 9.16944C40.4282 8.77202 38.3568 9.09883 36.5809 10.0912L28.757 14.4632C25.7102 16.1658 23.162 18.6361 21.3656 21.6286L17.5305 28.0173Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.0536,
    cy: 8.66266,
    r: 4.43415,
    transform: "rotate(-37.473 38.0536 8.66266)",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5305 28.0173L21.1663 20.3372C22.8467 16.7876 25.5351 13.8113 28.8959 11.7795L34.1394 8.60953C36.9305 6.92224 40.3328 6.58111 43.4033 7.68072C45.8702 8.56419 47.9336 10.3112 49.2119 12.5987L55.3768 23.6309L47.7788 12.6812C46.5159 10.8612 44.5959 9.60221 42.4233 9.16943C40.4282 8.77202 38.3568 9.09883 36.5809 10.0912L28.757 14.4632C25.7102 16.1658 23.162 18.6361 21.3656 21.6286L17.5305 28.0173Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8232 17.8747L51.7242 24.8161C53.9893 28.0244 55.2598 31.8285 55.3771 35.7541L55.5602 41.8785C55.6576 45.1385 54.2823 48.2691 51.8154 50.4025C49.8334 52.1165 47.2977 53.0547 44.6774 53.0434L32.0395 52.9891L45.3099 51.7549C47.5157 51.5497 49.5558 50.4966 51.0006 48.8173C52.3274 47.2752 53.061 45.3107 53.0698 43.2764L53.1083 34.3139C53.1233 30.8236 52.2246 27.3902 50.5016 24.3549L46.8232 17.8747Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5898,
    cy: 45.2611,
    r: 4.43415,
    transform: "rotate(81.9698 53.5898 45.2611)",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8232 17.8747L51.7242 24.8161C53.9893 28.0244 55.2598 31.8285 55.3771 35.7541L55.5602 41.8785C55.6576 45.1385 54.2823 48.2691 51.8154 50.4025C49.8334 52.1165 47.2977 53.0547 44.6774 53.0434L32.0395 52.9891L45.3099 51.7549C47.5157 51.5497 49.5558 50.4966 51.0006 48.8173C52.3274 47.2752 53.061 45.3107 53.0698 43.2764L53.1083 34.3139C53.1233 30.8236 52.2246 27.3902 50.5016 24.3549L46.8232 17.8747Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8165 49.8509L29.3379 49.2876C25.4193 49.0273 21.664 47.619 18.5404 45.2384L13.6672 41.5243C11.0733 39.5473 9.50722 36.5076 9.40314 33.2479C9.31953 30.6289 10.1873 28.0682 11.846 26.0397L19.8456 16.2559L12.4487 27.3424C11.2192 29.1852 10.7528 31.4332 11.1476 33.6131C11.5102 35.6148 12.5745 37.4217 14.1494 38.7094L21.0879 44.3826C23.7899 46.5919 27.023 48.0556 30.466 48.6283L37.8165 49.8509Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.2801,
    cy: 37.8638,
    r: 4.43415,
    transform: "rotate(-149.005 12.2801 37.8638)",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8165 49.8509L29.3379 49.2876C25.4193 49.0273 21.664 47.619 18.5404 45.2384L13.6672 41.5243C11.0733 39.5473 9.50722 36.5076 9.40314 33.2479C9.31953 30.6289 10.1873 28.0682 11.846 26.0397L19.8456 16.2559L12.4487 27.3424C11.2192 29.1852 10.7528 31.4332 11.1476 33.6131C11.5102 35.6148 12.5745 37.4217 14.1494 38.7094L21.0879 44.3826C23.7899 46.5919 27.023 48.0556 30.466 48.6283L37.8165 49.8509Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_42_1154)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.2908,
    cy: 29.797,
    rx: 4.43415,
    ry: 4.43415,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2349 27.4261L20.8708 19.746C22.5512 16.1964 25.2395 13.22 28.6004 11.1882L33.8439 8.01832C36.6349 6.33102 40.0373 5.98989 43.1077 7.0895C45.5746 7.97297 47.6381 9.72003 48.9163 12.0075L55.0812 23.0397L47.4832 12.09C46.2203 10.27 44.3004 9.01099 42.1278 8.57822C40.1327 8.1808 38.0612 8.50761 36.2854 9.49997L28.4615 13.872C25.4147 15.5746 22.8664 18.0449 21.0701 21.0373L17.2349 27.4261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.7581,
    cy: 8.07144,
    r: 4.43415,
    transform: "rotate(-37.473 37.7581 8.07144)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2349 27.4261L20.8708 19.746C22.5512 16.1964 25.2395 13.22 28.6004 11.1882L33.8439 8.01831C36.6349 6.33102 40.0373 5.98989 43.1077 7.0895C45.5746 7.97297 47.6381 9.72003 48.9163 12.0075L55.0812 23.0397L47.4832 12.09C46.2203 10.27 44.3004 9.01099 42.1278 8.57822C40.1327 8.1808 38.0612 8.50761 36.2854 9.49997L28.4615 13.872C25.4147 15.5746 22.8664 18.0449 21.0701 21.0373L17.2349 27.4261Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5277 17.2835L51.4286 24.2249C53.6938 27.4332 54.9643 31.2373 55.0816 35.1628L55.2647 41.2873C55.3621 44.5473 53.9867 47.6779 51.5198 49.8113C49.5379 51.5253 47.0021 52.4635 44.3818 52.4522L31.744 52.3979L45.0144 51.1636C47.2201 50.9585 49.2603 49.9054 50.7051 48.2261C52.0319 46.684 52.7655 44.7194 52.7743 42.6851L52.8127 33.7227C52.8277 30.2324 51.9291 26.799 50.2061 23.7637L46.5277 17.2835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.2943,
    cy: 44.6699,
    rx: 4.43415,
    ry: 4.43415,
    transform: "rotate(81.9698 53.2943 44.6699)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5277 17.2835L51.4286 24.2249C53.6938 27.4332 54.9643 31.2373 55.0816 35.1628L55.2647 41.2873C55.3621 44.5473 53.9867 47.6779 51.5198 49.8113C49.5379 51.5253 47.0021 52.4635 44.3818 52.4522L31.744 52.3979L45.0144 51.1636C47.2201 50.9585 49.2603 49.9054 50.7051 48.2261C52.0319 46.684 52.7655 44.7194 52.7743 42.6851L52.8127 33.7227C52.8277 30.2324 51.9291 26.799 50.2061 23.7637L46.5277 17.2835Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5209 49.2597L29.0424 48.6964C25.1237 48.4361 21.3684 47.0278 18.2449 44.6472L13.3717 40.9331C10.7778 38.9561 9.21168 35.9164 9.10761 32.6567C9.024 30.0377 9.89178 27.477 11.5504 25.4484L19.5501 15.6646L12.1532 26.7512C10.9237 28.594 10.4573 30.842 10.8521 33.0218C11.2147 35.0236 12.279 36.8305 13.8538 38.1182L20.7923 43.7914C23.4944 46.0007 26.7275 47.4644 30.1705 48.0371L37.5209 49.2597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.9846,
    cy: 37.2726,
    r: 4.43415,
    transform: "rotate(-149.005 11.9846 37.2726)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5209 49.2597L29.0424 48.6964C25.1237 48.4361 21.3684 47.0278 18.2449 44.6472L13.3717 40.9331C10.7778 38.9561 9.21168 35.9164 9.10761 32.6567C9.024 30.0377 9.89178 27.477 11.5504 25.4484L19.5501 15.6646L12.1532 26.7512C10.9237 28.594 10.4573 30.842 10.8521 33.0218C11.2147 35.0236 12.279 36.8305 13.8538 38.1182L20.7923 43.7914C23.4944 46.0007 26.7275 47.4644 30.1705 48.0371L37.5209 49.2597Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_42_1154)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.9952,
    cy: 29.2058,
    r: 4.43415,
    fill: "#4B7D3E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9393 26.8349L20.5751 19.1548C22.2556 15.6051 24.9439 12.6288 28.3048 10.597L33.5483 7.4271C36.3393 5.7398 39.7416 5.39867 42.8121 6.49829C45.279 7.38175 47.3424 9.12881 48.6207 11.4162L54.7856 22.4485L47.1876 11.4988C45.9247 9.67874 44.0048 8.41977 41.8321 7.987C39.837 7.58958 37.7656 7.91639 35.9897 8.90875L28.1658 13.2808C25.119 14.9834 22.5708 17.4536 20.7744 20.4461L16.9393 26.8349Z",
    fill: "#4B7D3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4624,
    cy: 7.48023,
    r: 4.43415,
    transform: "rotate(-37.473 37.4624 7.48023)",
    fill: "#4B7D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9393 26.8349L20.5751 19.1548C22.2556 15.6051 24.9439 12.6288 28.3048 10.597L33.5483 7.4271C36.3393 5.7398 39.7416 5.39868 42.8121 6.49829C45.279 7.38176 47.3424 9.12881 48.6207 11.4162L54.7856 22.4485L47.1876 11.4988C45.9247 9.67874 44.0048 8.41977 41.8321 7.987C39.837 7.58958 37.7656 7.91639 35.9897 8.90875L28.1658 13.2808C25.119 14.9834 22.5708 17.4536 20.7744 20.4461L16.9393 26.8349Z",
    fill: "#4B7D3E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.232 16.6923L51.133 23.6337C53.3981 26.8419 54.6686 30.6461 54.7859 34.5716L54.969 40.6961C55.0664 43.9561 53.6911 47.0867 51.2242 49.22C49.2422 50.9341 46.7065 51.8722 44.0862 51.861L31.4484 51.8067L44.7187 50.5724C46.9245 50.3673 48.9646 49.3142 50.4094 47.6349C51.7362 46.0928 52.4699 44.1282 52.4786 42.0939L52.5171 33.1314C52.5321 29.6412 51.6334 26.2078 49.9104 23.1725L46.232 16.6923Z",
    fill: "#4B7D3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.9987,
    cy: 44.0787,
    r: 4.43415,
    transform: "rotate(81.9698 52.9987 44.0787)",
    fill: "#4B7D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.232 16.6923L51.133 23.6337C53.3981 26.8419 54.6686 30.6461 54.7859 34.5716L54.969 40.6961C55.0664 43.9561 53.6911 47.0867 51.2242 49.22C49.2422 50.9341 46.7065 51.8722 44.0862 51.861L31.4484 51.8067L44.7187 50.5724C46.9245 50.3673 48.9646 49.3142 50.4094 47.6349C51.7362 46.0928 52.4699 44.1282 52.4786 42.0939L52.5171 33.1314C52.5321 29.6412 51.6334 26.2078 49.9104 23.1725L46.232 16.6923Z",
    fill: "#4B7D3E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_42_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2253 48.6685L28.7467 48.1052C24.8281 47.8449 21.0728 46.4366 17.9492 44.056L13.076 40.3419C10.4821 38.3649 8.91603 35.3252 8.81196 32.0655C8.72834 29.4465 9.59613 26.8858 11.2548 24.8572L19.2544 15.0734L11.8575 26.16C10.628 28.0028 10.1616 30.2508 10.5564 32.4306C10.919 34.4324 11.9833 36.2393 13.5582 37.527L20.4967 43.2002C23.1987 45.4095 26.4319 46.8732 29.8748 47.4459L37.2253 48.6685Z",
    fill: "#4B7D3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.6889,
    cy: 36.6814,
    r: 4.43415,
    transform: "rotate(-149.005 11.6889 36.6814)",
    fill: "#4B7D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2253 48.6685L28.7467 48.1052C24.8281 47.8449 21.0728 46.4366 17.9492 44.056L13.076 40.3419C10.4821 38.3649 8.91603 35.3252 8.81196 32.0655C8.72834 29.4465 9.59613 26.8858 11.2548 24.8572L19.2544 15.0734L11.8575 26.16C10.628 28.0028 10.1616 30.2508 10.5564 32.4306C10.919 34.4324 11.9833 36.2393 13.5582 37.527L20.4967 43.2002C23.1987 45.4095 26.4319 46.8732 29.8748 47.4459L37.2253 48.6685Z",
    fill: "#4B7D3E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_42_1154",
    x: 103.62,
    y: 18.8,
    width: 49.8671,
    height: 29.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_42_1154",
    x: 79.196,
    y: 18.44,
    width: 27.5039,
    height: 29.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_42_1154",
    x: 102.62,
    y: 18.8,
    width: 49.8671,
    height: 29.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_42_1154",
    x: 78.196,
    y: 18.44,
    width: 27.5039,
    height: 29.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_42_1154",
    x: -4,
    y: 0,
    width: 79.2876,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_1154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_1154",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_42_1154",
    x: 30.1522,
    y: 25.9541,
    width: 8.86829,
    height: 12.8683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_42_1154",
    x: 17.5305,
    y: 4.22827,
    width: 37.8462,
    height: 27.789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_42_1154",
    x: 32.0396,
    y: 17.8747,
    width: 25.985,
    height: 39.1688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_42_1154",
    x: 7.84534,
    y: 16.2559,
    width: 29.9711,
    height: 37.5951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_42_1154",
    x: 29.8567,
    y: 25.3629,
    width: 8.86829,
    height: 12.8683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_42_1154",
    x: 17.235,
    y: 3.63705,
    width: 37.8462,
    height: 27.789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_42_1154",
    x: 31.744,
    y: 17.2835,
    width: 25.985,
    height: 39.1688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_42_1154",
    x: 7.5498,
    y: 15.6646,
    width: 29.9711,
    height: 37.5951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_42_1154",
    x: 29.561,
    y: 24.7716,
    width: 8.86829,
    height: 12.8683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_42_1154",
    x: 16.9393,
    y: 3.04584,
    width: 37.8462,
    height: 27.789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_42_1154",
    x: 31.4484,
    y: 16.6923,
    width: 25.985,
    height: 39.1688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_42_1154",
    x: 7.25415,
    y: 15.0734,
    width: 29.9711,
    height: 37.5951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42_1154"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.2876,
    height: 70,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofull);
export default __webpack_public_path__ + "static/media/logofull.b9b22d2f6c097ba28632103bb42de9d7.svg";
export { ForwardRef as ReactComponent };